var styledFooter = 'fx_2d2fb1e5_138v3l50';

export { styledFooter };
//# sourceMappingURL=footer.vanilla.mjs.map
